import { FC, ReactNode, useState } from 'react';
import { BookingSlotsContext } from '../../lib/helpers/context';

interface SlotsProviderProps {
	children: ReactNode;
}

export const BookingSlotsProvider: FC<SlotsProviderProps> = ({ children }) => {
	const [currentActive, setCurrentActive] = useState<string>('');

	return (
		<BookingSlotsContext.Provider
			value={{ setCurrentActive, currentActive }}
		>
			{children}
		</BookingSlotsContext.Provider>
	);
};
